import { Normal6 } from 'components/Typography';
import { useTranslation } from 'react-i18next';
import { ClaimPagePanelTestnet } from '../ClaimPagePanel/ClaimPagePanelTestnet';
import { ClaimList } from '../ClaimList/ClaimList';

export function ClaimPageContainer({ isTestnet }: { isTestnet: boolean }) {
  const { t } = useTranslation('claim');
  return (
    <div className='relative mx-auto mt-8 flex w-full flex-col gap-6 p-4 px-3 max-lg:mt-0 lg:p-0'>
      <Normal6 className='font-bold text-white'>
        {isTestnet
          ? t('SINGULARITY_FINANCE_TESTNET_REWARDS')
          : t('SINGULARITY_FINANCE_CLAIM_TOKENS')}
      </Normal6>
      {isTestnet ? <ClaimPagePanelTestnet /> : <ClaimList />}
    </div>
  );
}
